<template>
  <modal @before-open="beforeOpen" @opened="opened" name="orderUserList" :clickToClose="true" :draggable="'.header'" :reset="true"
         :classes="['schedule','generalbox']"
         :adaptive="true" :pivotX="modalOffsetDistance.x" :pivotY="modalOffsetDistance.y"
          :height="'80%'" :width="'80%'" :max-width="1540" :min-width="600" :min-height="600"
         :click-to-close="false">

    <div class="header">
      <h2>预约用户列表</h2>
      <div @click="close" class="close">
        <i class="iconfont icon-cha"></i>
      </div>
    </div>
    <div class="content">

      <!--<h2>预约用户列表</h2>-->
      <p class="info">{{info.sysName}} {{info.day}} {{info.typeDesc}}</p>
      <h2 v-if="!userList.length" class="nodata">预约列表为空</h2>
      <ul class="userlist">
        <li v-for="user in userList">
          <img :src="user.avatar" alt="">
          <p>{{user.dept.deptName}} {{user.userName}}</p>
          <span>{{user.tel}}</span>
          <span>{{user.userType | getUserTypeDesc}}</span>
          <div class="desc time">
            <p>预约时间：{{user.createTime}}</p>
          </div>
          <div v-if="!user.state" class="btnlist">
            <button @click="signUserState(user,1)">处理完</button>
            <button @click="signUserState(user,2)">已爽约</button>
          </div>

          <div class="desc">{{user.state|getStateDesc}}</div>

        </li>
      </ul>
    </div>

  </modal>
</template>

<script>
  //通信总线
  import Bus from 'common/js/bus.js';
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  export default {
    name: "orderUserList",
    data() {
      return {
        info:{},
        userList:[]
      }
    },
    computed: {
      ...mapState(['modalOffsetDistance'])
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("orderUserList");
      },
      beforeOpen(data){
        this.info=data.params;
        this.initUserList()
      },
      opened(){
        this.updateModalZIndex(this.$el)
      },
      async initUserList(){
        let userList=await axios.post(apiConfig.REQUEST_URL+'/shall/front_orderUserList?' + this.$qs.stringify(this.info));
        this.userList=userList.data.data;
        console.log('------>>>>>this.userList')
        console.log(this.userList)
      },
      async signUserState(user,state){
        let signResult=await axios.post(apiConfig.REQUEST_URL+'/shall/front_updateOrderUser?' + this.$qs.stringify({
          sysId: this.info.sysId,
          day: this.info.day,
          type: this.info.type,
          userId: user.userId,
          state: state
        }))
        this.initUserList()
        Bus.$emit('updateUserInfo',signResult.data)

      }
    },
    filters:{
      getUserTypeDesc(val){
        val=parseInt(val);
        if(!val && val!==0) return
        let desc='';
        switch (val) {
          case 1:
            desc='老师'
            break;
          case 2:
            desc='学生'
            break;
          case 3:
            desc='管理员'
            break;
          default:
            console.log('getUserTypeDesc参数异常')
        }
        return desc;
      },
      getStateDesc(val){
        switch (val) {
          case 1:
            return '已办理'
          case 2:
            return '已爽约'
        }
      }
    },

    mounted() {

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    h2
      font-size 16px
      color #333333
      text-align center
      line-height 60px

    h2.nodata
      font-size 14px
      color #666666
    &>.info
      text-align center
      color #999999
      margin-top 20px
      margin-bottom 10px
      font-size 14px
    .userlist
      width 100%
      margin auto
      li
        border-bottom 1px solid #eeeeee
        height 60px
        line-height 40px
        padding 10px 30px
        img
          border 1px solid #eeeeee
          display block
          width 40px
          height 40px
          border-radius 50%
          margin-right 10px
          float left
        p
          min-width 160px
          color #666666
          display inline-block
        span
          font-size 14px
          margin-left 5px
          color #999999
          display inline-block
        .btnlist
          margin-left 20px
          display inline-block
          float right
          button
            outline none
            height 24px
            width 60px
            font-size 14px
            color #666666
            border-radius 12px
            background-color #ffffff
            border 1px solid #cccccc
            transition 300ms
            &:hover
              background-color #eeeeee
        .desc
          margin 0 10px
          display inline-block
          color #666666
          font-size 14px
          float right
          &.time
            float none
            margin-left 20px
            p
              font-size 14px
              color #999
</style>



// WEBPACK FOOTER //
// src/components/order/orderUserListModal.vue